module.exports = __webpack_public_path__ + "catalog/items/firesafety/Smoke-Detector-V1/Smoke-Detector-V1.svg";